/* global window */
import { Container } from 'react-bootstrap';
import { LoadingContext } from './context/LoadingContext';
import React, { useCallback, useContext } from 'react';
import { useParams } from 'react-router-dom';
import usePrefetch from '../hooks/usePrefetch';
import '../styles/FaqPage.css';


/**
 * Fetch FAQ content.
 */
const fetchFaqContent = async (handle) => {
    const response = await fetch(new URL(`/api/faqs/faqContent/${handle}`, process.env.APP_URL));
    const data = await response.json();
    return data?.faqContent ?? null;
};

const FaqPage = ({}) => {
    const { finishLoading, startLoading } = useContext(LoadingContext);
    const { handle } = useParams();

    const {
        isLoaded,
        data: faqContent,
    } = usePrefetch({
        key: 'faq',
        resourceKey: 'handle',
        resourceValue: handle,
        prefetchFn: async () => {
            await startLoading();
            const data = await fetchFaqContent(handle);
            await finishLoading();
            return data;
        }
    });

    const targetFaqRef = useCallback((faqNode) => window.scrollTo({
        top: faqNode?.offsetTop ?? 0,
        behavior: 'smooth',
    }), []);

    return <Container>
        <h1>HELP</h1>
        <hr />
        {isLoaded === true
            ? <>
                <h2>{faqContent.title}</h2>
                <div
                    className={'faq-page--faq-container'}>
                    {faqContent.Faqs.map((faq, faqIndex) => <div
                        className={'faq-page--faq-item'}
                        id={faq.id}
                        key={faqIndex}
                        ref={String(faq.id) === window.location.hash.replace('#', '') ? targetFaqRef : null}>
                        <div
                            dangerouslySetInnerHTML={{__html: faq.question}}></div>
                        <hr />
                        <div
                            dangerouslySetInnerHTML={{__html: faq.answer}}></div>
                    </div>)}
                </div>
            </>
            : <p>Fetching help content...</p>
        }
    </Container>;
};

export default FaqPage;